import React from 'react';
import EditIcon from '../../assets/edit_b3.svg';
import DeleteIcon from '../../assets/trash_b3.svg';
import CustomMenu from './CustomMenu';

const ActionMenu = ({
  anchorEl,
  open,
  onClose,
  onEdit,
  onDelete,
  editText = '수정',
  deleteText = '삭제',
  showEdit = true,
  showDelete = true,
}) => {
  const menuItems = [];

  // 수정 메뉴 아이템
  if (showEdit) {
    menuItems.push({
      text: editText,
      onClick: onEdit,
      icon: EditIcon,
      iconAlt: 'Edit',
    });
  }

  // 삭제 메뉴 아이템
  if (showDelete) {
    menuItems.push({
      text: deleteText,
      onClick: onDelete,
      icon: DeleteIcon,
      iconAlt: 'Delete',
    });
  }

  return (
    <CustomMenu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      items={menuItems}
    />
  );
};

export default ActionMenu;
